<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
  <div class="container-header-inner-list">
    <div class="row mb-4">
      <div class="col-md-6">
        <div class="title-wrapper">
          <div>
            <h1 class="title-default">Inventário de Estoque</h1>
            <p class="welcome-message">
              <button mat-icon-button (click)="voltar()" matTooltip="Voltar para Controle de Estoque">
                <mat-icon>arrow_back</mat-icon>
              </button>
              Realize contagens periódicas e mantenha o estoque alinhado com a realidade física.
            </p>
          </div>
        </div>
      </div>

      <div class="col-md-6 header-actions">
        <button mat-stroked-button class="btn-secondary" [matMenuTriggerFor]="opcoesMenu">
          <span>Ações</span>
          <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
        </button>

        <mat-menu #opcoesMenu="matMenu">
          <button mat-menu-item routerLink="/suprimentos/inventario/filtrar-produtos">
            <mat-icon class="material-symbols-outlined">filter_list</mat-icon>
            <span>Filtrar produtos</span>
          </button>
          <button mat-menu-item routerLink="/suprimentos/inventario/importar-planilha">
            <mat-icon class="material-symbols-outlined">table</mat-icon>
            <span>Importar por planilha</span>
          </button>
          <button mat-menu-item routerLink="/suprimentos/inventario/importar-coletor">
            <mat-icon class="material-symbols-outlined">barcode_scanner</mat-icon>
            <span>Importar por coletor</span>
          </button>
        </mat-menu>

        <button type="button" mat-flat-button class="btn-primary" routerLink="/suprimentos/inventario/novo">
          <span class="material-symbols-outlined">add</span>
          Novo Inventário de Estoque
        </button>
      </div>
    </div>

    <div class="action-card-grid">
      <a class="action-card-link" routerLink="/suprimentos/inventario/filtrar-produtos">
        <app-action-card
          icon="filter_list"
          title="Filtrar produtos"
          description="Procure os produtos e escolha entre gerar o inventário manualmente ou exportar a lista."
          [interactive]="true">
        </app-action-card>
      </a>
      <a class="action-card-link" routerLink="/suprimentos/inventario/importar-planilha">
        <app-action-card
          icon="table"
          title="Importar por planilha"
          description="Baixe o modelo de planilha, preencha com seus dados e importe o arquivo final para gerar o inventário automaticamente."
          [interactive]="true">
        </app-action-card>
      </a>
      <a class="action-card-link" routerLink="/suprimentos/inventario/importar-coletor">
        <app-action-card
          icon="barcode_scanner"
          title="Importar por coletor"
          description="Realize a contagem com um coletor de dados e importe o arquivo gerado para criar o inventário."
          [interactive]="true">
        </app-action-card>
      </a>
    </div>

    <form [formGroup]="model" (ngSubmit)="clickPesquisar()">
      <div class="row search-area">
        <div class="col-12 col-lg-6">
          <mat-form-field appearance="outline">
            <mat-label>Pesquisar</mat-label>
            <input matInput type="text" formControlName="descricao"
              placeholder="Pesquise por descrição do inventário" />
            <button mat-icon-button matSuffix type="submit" aria-label="Pesquisar">
              <mat-icon>search</mat-icon>
            </button>
          </mat-form-field>
        </div>

        <div class="col-12 col-lg-6 filter-container">
          <button #filtrosAvancadosMenuTrigger="matMenuTrigger" mat-stroked-button type="button" class="btn-filter"
            [matMenuTriggerFor]="filtroMenu" [matBadge]="qtdFiltrosAvancados"
            [matBadgeHidden]="qtdFiltrosAvancados === 0">
            <mat-icon>filter_list</mat-icon>
            Filtrar
          </button>

          <mat-menu #filtroMenu="matMenu" class="filter-custom-menu">
            <div class="filter-menu-content" [formGroup]="model" (click)="$event.stopPropagation()">
              <h6>Filtros</h6>
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Status</mat-label>
                <mat-select formControlName="idStatusInventario">
                  <mat-option [value]="null">Todos</mat-option>
                  @for (status of lookup.statusList; track status.idStatusInventario) {
                  <mat-option [value]="status.idStatusInventario">{{ status.descricao }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Origem</mat-label>
                <mat-select formControlName="idTipoOrigemInventario">
                  <mat-option [value]="null">Todas</mat-option>
                  @for (origem of lookup.tipoOrigemList; track origem.idTipoOrigemInventario) {
                  <mat-option [value]="origem.idTipoOrigemInventario">{{ origem.descricao }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <div class="filter-menu__actions">
                <button mat-button class="btn-secondary" matMenuClose
                  (click)="filtrosAvancadosMenuTrigger.closeMenu()">Cancelar</button>
                <button mat-flat-button class="btn-primary" (click)="aplicarFiltros()" matMenuClose>Aplicar</button>
              </div>
            </div>
          </mat-menu>

          <button mat-stroked-button type="button" class="btn-filter" (click)="limparFiltros()">
            <mat-icon>cleaning_services</mat-icon>
            Limpar Filtros
          </button>
        </div>
      </div>
    </form>

    @if (_isLoading && _dataSource.data.length === 0) {
    <app-loading-box-default-list></app-loading-box-default-list>
    } @else if (!_isLoading && _dataSource.data.length === 0) {
    <app-empty-list [title]="'Nenhum inventário encontrado'"
      [subTitle]="'Tente alterar os filtros de busca'"></app-empty-list>
    }

    @if (_dataSource.data.length > 0) {
    <div class="table-responsive desktop-view">
      <table mat-table [dataSource]="_dataSource" class="mat-elevation-z0">

        <ng-container matColumnDef="descricao">
          <th mat-header-cell *matHeaderCellDef>Descrição</th>
          <td mat-cell *matCellDef="let row">{{ row.descricao }}</td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let row">
            <span class="status-badge" [ngClass]="getStatusClass(row.idStatusInventario)">
              {{ row.descricaoStatus }}
            </span>
            @if (row.mensagemProcessamento) {
              <mat-icon class="material-symbols-outlined status-info-icon" [matTooltip]="row.mensagemProcessamento">info</mat-icon>
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="origem">
          <th mat-header-cell *matHeaderCellDef>Origem</th>
          <td mat-cell *matCellDef="let row">{{ row.descricaoTipoOrigem }}</td>
        </ng-container>

        <ng-container matColumnDef="dataInclusao">
          <th mat-header-cell *matHeaderCellDef>Data de criação</th>
          <td mat-cell *matCellDef="let row">{{ row.datetimeInclusao | date: 'dd/MM/yyyy HH:mm' }}</td>
        </ng-container>
        <ng-container matColumnDef="dataConclusao">
          <th mat-header-cell *matHeaderCellDef>Conclusão / Cancelamento</th>
          <td mat-cell *matCellDef="let row">
            @if (row.datetimeConclusao) {
            {{ row.datetimeConclusao | date: 'dd/MM/yyyy HH:mm' }}
            } @else if (row.datetimeCancelamento) {
            {{ row.datetimeCancelamento | date: 'dd/MM/yyyy HH:mm' }}
            } @else {
            —
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef class="col-actions">Ações</th>
          <td mat-cell *matCellDef="let row" class="col-actions">
            <button mat-icon-button [matMenuTriggerFor]="rowMenu" matTooltip="Opções"
              (click)="$event.stopPropagation()">
              <span class="material-symbols-outlined">more_horiz</span>
            </button>
            <mat-menu #rowMenu="matMenu">
              <button mat-menu-item (click)="verResumo(row)">
                <mat-icon class="material-symbols-outlined">summarize</mat-icon>
                <span>Ver resumo</span>
              </button>
              <button mat-menu-item [routerLink]="['/suprimentos/inventario', row.idInventario]">
                <mat-icon class="material-symbols-outlined">edit_note</mat-icon>
                <span>{{ isPendente(row) ? 'Editar' : 'Visualizar' }}</span>
              </button>
              <button mat-menu-item (click)="excluir(row)" [disabled]="!isPendente(row)"
                matTooltip="Apenas inventários pendentes podem ser excluídos" [matTooltipDisabled]="isPendente(row)">
                <mat-icon class="material-symbols-outlined is-error">delete</mat-icon>
                <span>Excluir</span>
              </button>
              <button mat-menu-item (click)="exportar(row)" [disabled]="!isConcluido(row)"
                matTooltip="Disponível apenas para inventários concluídos" [matTooltipDisabled]="isConcluido(row)">
                <mat-icon class="material-symbols-outlined">download</mat-icon>
                <span>Exportar</span>
              </button>
            </mat-menu>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>

    <div class="mobile-view">
      @for (row of _dataSource.data; track row.idInventario) {
      <div class="inv-card">
        <div class="inv-card__header">
          <strong>{{ row.descricao }}</strong>
          <button mat-icon-button [matMenuTriggerFor]="rowMenuMobile" aria-label="Ações">
            <span class="material-symbols-outlined">more_horiz</span>
          </button>
          <mat-menu #rowMenuMobile="matMenu">
            <button mat-menu-item (click)="verResumo(row)">
              <mat-icon class="material-symbols-outlined">summarize</mat-icon>
              <span>Ver resumo</span>
            </button>
            <button mat-menu-item [routerLink]="['/suprimentos/inventario', row.idInventario]">
              <mat-icon class="material-symbols-outlined">edit_note</mat-icon>
              <span>{{ isPendente(row) ? 'Editar' : 'Visualizar' }}</span>
            </button>
            <button mat-menu-item (click)="excluir(row)" [disabled]="!isPendente(row)"
              matTooltip="Apenas inventários pendentes podem ser excluídos" [matTooltipDisabled]="isPendente(row)">
              <mat-icon class="material-symbols-outlined is-error">delete</mat-icon>
              <span>Excluir</span>
            </button>
            <button mat-menu-item (click)="exportar(row)" [disabled]="!isConcluido(row)"
              matTooltip="Disponível apenas para inventários concluídos" [matTooltipDisabled]="isConcluido(row)">
              <mat-icon class="material-symbols-outlined">download</mat-icon>
              <span>Exportar</span>
            </button>
          </mat-menu>
        </div>
        <div class="inv-card__grid">
          <div>
            <small>Status</small>
            <span class="status-badge" [ngClass]="getStatusClass(row.idStatusInventario)">{{ row.descricaoStatus
              }}</span>
            @if (row.mensagemProcessamento) {
              <mat-icon class="material-symbols-outlined status-info-icon" [matTooltip]="row.mensagemProcessamento">info</mat-icon>
            }
          </div>
          <div>
            <small>Origem</small>
            <span>{{ row.descricaoTipoOrigem }}</span>
          </div>
          <div>
            <small>Data de criação</small>
            <span>{{ row.datetimeInclusao | date: 'dd/MM/yyyy HH:mm' }}</span>
          </div>
          <div>
            <small>Conclusão / Cancelamento</small>
            <span>
              @if (row.datetimeConclusao) {
              {{ row.datetimeConclusao | date: 'dd/MM/yyyy HH:mm' }}
              } @else if (row.datetimeCancelamento) {
              {{ row.datetimeCancelamento | date: 'dd/MM/yyyy HH:mm' }}
              } @else {
              —
              }
            </span>
          </div>
        </div>
      </div>
      }
    </div>

    <div class="col-12 text-center mt-4 mb-5">
      <button mat-button class="btn-ver-mais" [disabled]="_isLoading || _ultimaPagina" (click)="proximaPagina()">
        @if (_isLoading === true) {
        <mat-spinner [diameter]="20"></mat-spinner>
        } @else {
        <span class="material-symbols-outlined">expand_more</span>
        Ver Mais
        }
      </button>
    </div>
    }
  </div>
</div>
